import { LifeBuoy } from "lucide-react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ProfileForm } from "@/components/account/ProfileForm";
import { ChangePasswordCard } from "@/components/account/ChangePasswordCard";
import { TwoFactorCard } from "@/components/account/TwoFactorCard";
import { useAuth } from "@/hooks/useAuth";

export function SettingsPage() {
  const { logout } = useAuth();

  return (
    <div className="space-y-5 sm:space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground sm:text-base">
          Account-level configuration. Domain + service settings live on each domain's page.
        </p>
      </div>

      <ProfileForm />

      <ChangePasswordCard />

      <TwoFactorCard />

      <Card className="border-destructive/30">
        <CardHeader>
          <CardTitle className="text-destructive">Danger zone</CardTitle>
          <CardDescription>
            Sign out everywhere. Cancelling subscriptions or deleting domains is handled on
            the relevant pages.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-destructive/10 text-destructive">
              <LifeBuoy className="h-5 w-5" />
            </div>
            <div>
              <p className="font-medium">Sign out of this session</p>
              <p className="text-xs text-muted-foreground">
                Revokes only this browser's JWT cookie.
              </p>
            </div>
          </div>
          <Button variant="outline" onClick={() => void logout()}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
